"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/footerSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionIconsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Facebook" | "Twitter" | "LinkedIn" | "Instagram" */
    ariaLabel: string;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-linkedin-in" | "fa-brands fa-instagram" */
    className: string;
    /** Detected variants: "icon" */
    aClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSection3457sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-3 col-lg-4 col-md-5 col-sm-7" | "col-xl-2 col-lg-3 col-md-2 col-sm-5" */
    className: string;
    /** Detected variants: "Our Services" | "Company" */
    h20Text: ReactNode;
    /** Detected variants: "footer-widget" */
    div0ClassName?: string;
    /** Detected variants: "footer-title" */
    h20ClassName?: string;
    footerMenuItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Sports Injury Recovery" | "Post Surgery Rehabilitation" | "Pain Management Treatments" | "Mobility & Movement Therapy" | "Rehabilitation & Physical Therapy" | "About" | "Clinics" | "Hospitals" | "Specialities" | "Contact Us" */
    a0Text: ReactNode;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "icon" */
    className?: string;
    /** Detected variants: "isax isax-arrow-right-34" */
    i0ClassName?: string;
};
export type HomeEighteenFooterSectionGeneratedProps = {
    divDiv0H20H2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSection3457sItem) => Partial<ComponentProps<"h2">>);
    /** Default: "Ready to Start Your Recovery?" */
    footerDiv0Div0Div0H20H2Text?: ReactNode;
    footerDiv0Div0Div0H20H2Visible?: boolean;
    footerDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Let's talk about your goals and create a plan to get you moving better" */
    footerDiv0Div0Div0P0PText?: ReactNode;
    /** Default: "#" */
    footerDiv0Div0Div1A0AHref?: string;
    /** Default: "Schedule Your Consultation" */
    footerDiv0Div0Div1A0AText?: ReactNode;
    footerDiv0Div1ClassName?: string;
    /** Default: "#" */
    footerDiv0Div1Div0Div0Div0A0AHref?: string;
    /** Default: "logo" */
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-18.svg" */
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "We Are Available !!" */
    footerDiv0Div1Div0Div0Div1H30H3Text?: ReactNode;
    footerDiv0Div1Div0Div0Div1H30H3Visible?: boolean;
    footerDiv0Div1Div0Div0Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div0Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Monday - Friday : 8:30 AM to 6:30 PM" */
    footerDiv0Div1Div0Div0Div1P0PText?: ReactNode;
    /** Default: "Every member of our team is committed to evidence-based care, ongoing education, and helping you achieve your health goals" */
    footerDiv0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "Scroll to top" */
    footerDiv1A0AAriaLabel?: string;
    /** Default: "#" */
    footerDiv1A0AHref?: string;
    /** Default: "Copyright &copy; 2026" */
    footerDiv1Div0P0PText?: ReactNode;
    /** Default: ". All Rights Reserved" */
    footerDiv1Div0P0PText2?: ReactNode;
    /** Default: "#" */
    footerDiv1Div0P0A0AHref?: string;
    /** Default: "Doccure" */
    footerDiv1Div0P0A0AText?: ReactNode;
    /** Default: "footer" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/footer-img-1.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-shadow-1.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer" */
    footerImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-shadow-2.png" */
    footerImageWithBasePath2ImageSrc?: string;
    footerImageWithBasePath2ImageVisible?: boolean;
    footerImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerSectionIcons: FooterSectionIconsItem[];
    footerSection3457s: FooterSection3457sItem[];
    footerSectionIconsItemWrapper?: (item: FooterSectionIconsItem, content: ReactNode) => ReactNode;
    footerSectionIconsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection3457sItemWrapper?: (item: FooterSection3457sItem, content: ReactNode) => ReactNode;
    footerSection3457sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection3457sH2Visible?: boolean;
    footerSection3457sH2Renderer?: (item: FooterSection3457sItem, defaultNode: ReactNode) => ReactNode;
    footerSection3457sH2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSection3457sItem) => Partial<ComponentProps<"h2">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeEighteenFooterSectionGenerated: FC<HomeEighteenFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0H20H2Text = "Ready to Start Your Recovery?",
    footerDiv0Div0Div0H20H2Visible,
    footerDiv0Div0Div0H20H2Renderer,
    footerDiv0Div0Div0H20H2Props,
    footerDiv0Div0Div0P0PText = "Let's talk about your goals and create a plan to get you moving better",
    footerDiv0Div0Div1A0AHref = "#",
    footerDiv0Div0Div1A0AText = "Schedule Your Consultation",
    footerDiv0Div1Div0Div0Div0A0AHref = "#",
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageAlt = "logo",
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-18.svg",
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageVisible,
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageRenderer,
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageProps,
    footerDiv0Div1Div0Div0Div1H30H3Text = "We Are Available !!",
    footerDiv0Div1Div0Div0Div1H30H3Visible,
    footerDiv0Div1Div0Div0Div1H30H3Renderer,
    footerDiv0Div1Div0Div0Div1H30H3Props,
    footerDiv0Div1Div0Div0Div1P0PText = "Monday - Friday : 8:30 AM to 6:30 PM",
    footerDiv0Div1Div0Div0P0PText = "Every member of our team is committed to evidence-based care, ongoing education, and helping you achieve your health goals",
    footerDiv1A0AAriaLabel = "Scroll to top",
    footerDiv1A0AHref = "#",
    footerDiv1Div0P0A0AHref = "#",
    footerDiv1Div0P0A0AText = "Doccure",
    footerDiv1Div0P0PText = "Copyright &copy; 2026",
    footerDiv1Div0P0PText2 = ". All Rights Reserved",
    footerImageWithBasePath0ImageAlt = "footer",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/footer-img-1.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "footer",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-shadow-1.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    footerImageWithBasePath2ImageAlt = "footer",
    footerImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/footer-shadow-2.png",
    footerImageWithBasePath2ImageVisible,
    footerImageWithBasePath2ImageRenderer,
    footerImageWithBasePath2ImageProps,
    divDiv0H20H2Props,
    footerDiv0Div1ClassName,
    footerSectionIcons,
    footerSection3457s,
    footerSectionIconsItemWrapper,
    footerSectionIconsRenderer,
    footerSection3457sItemWrapper,
    footerSection3457sRenderer,
    footerSection3457sH2Visible,
    footerSection3457sH2Renderer,
    footerSection3457sH2Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
}) => {
    return (
        <footer className="footer-eighteen position-relative">
            <div className="container">
                <div className="footer-support">
                    <div className="footer-text">
                        {renderNode(footerDiv0Div0Div0H20H2Visible, footerDiv0Div0Div0H20H2Renderer, (
                            <h2 className="title" {...(footerDiv0Div0Div0H20H2Props ?? {})}>{footerDiv0Div0Div0H20H2Text}</h2>
                        ))}
                        <p className="description">{footerDiv0Div0Div0P0PText}</p>
                    </div>
                    <div className="footer-link">
                        <a href={footerDiv0Div0Div1A0AHref} className="theme-18-btn btn">
                            {footerDiv0Div0Div1A0AText}
                            <span className="icon">
                                <i className="fa-solid fa-arrow-right"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div className={footerDiv0Div1ClassName ?? "row row-gap-5"}>
                    <div className="col-xl-4 col-lg-5 col-md-5">
                        <div className="footer-about">
                            <div className="footer-logo">
                                <a href={footerDiv0Div1Div0Div0Div0A0AHref}>
                                    {renderNode(footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageVisible, footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageSrc} alt={footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageAlt} className="img-fluid" {...(footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </a>
                            </div>
                            <p className="description">{footerDiv0Div1Div0Div0P0PText}</p>
                            <div className="footer-content">
                                {renderNode(footerDiv0Div1Div0Div0Div1H30H3Visible, footerDiv0Div1Div0Div0Div1H30H3Renderer, (
                                    <h3 className="text" {...(footerDiv0Div1Div0Div0Div1H30H3Props ?? {})}>{footerDiv0Div1Div0Div0Div1H30H3Text}</h3>
                                ))}
                                <p className="time">{footerDiv0Div1Div0Div0Div1P0PText}</p>
                            </div>
                        </div>
                    </div>
                    {renderCollectionNode(
                        footerSection3457s,
                        (item: FooterSection3457sItem) => (
                            <div className={item.className} key={item.key}>
                                <div className={item.div0ClassName ?? "footer-widget"}>
                                    {renderItemNode(footerSection3457sH2Visible, footerSection3457sH2Renderer, item, (
                                        <h2 className={item.h20ClassName ?? "footer-title"} {...(typeof footerSection3457sH2Props === "function" ? footerSection3457sH2Props(item) : (footerSection3457sH2Props ?? {}))} {...(typeof divDiv0H20H2Props === "function" ? divDiv0H20H2Props(item) : (divDiv0H20H2Props ?? {}))}>{item.h20Text}</h2>
                                    ))}
                                    <ul className="footer-menu">
                                        {renderCollectionNode(
                                            item.footerMenuItems ?? [],
                                            (item: FooterSectionUlsItem) => (
                                                <li key={item.key}>
                                                    <a href={item.href ?? "#"}>
                                                        <span className={item.className ?? "icon"}>
                                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-34"}></i>
                                                        </span>
                                                        {item.a0Text}
                                                    </a>
                                                </li>
                                            ),
                                            footerSectionUlsItemWrapper,
                                            footerSectionUlsRenderer
                                        )}
                                    </ul>
                                </div>
                            </div>
                        ),
                        footerSection3457sItemWrapper,
                        footerSection3457sRenderer
                    )}
                </div>
            </div>
            <div className="footer-copy">
                <div className="container">
                    <p className="copyright">
                        {footerDiv1Div0P0PText}
                        <a href={footerDiv1Div0P0A0AHref}>{footerDiv1Div0P0A0AText}</a>
                        {footerDiv1Div0P0PText2}
                    </p>
                    <div className="social-icon">
                        {renderCollectionNode(
                            footerSectionIcons,
                            (item: FooterSectionIconsItem) => (
                                <a href={item.href ?? "#"} className={item.aClassName ?? "icon"} aria-label={item.ariaLabel} key={item.key}>
                                    <i className={item.className}></i>
                                </a>
                            ),
                            footerSectionIconsItemWrapper,
                            footerSectionIconsRenderer
                        )}
                    </div>
                </div>
                <a href={footerDiv1A0AHref} className="top-btn" aria-label={footerDiv1A0AAriaLabel}>
                    <i className="isax isax-arrow-up-25"></i>
                </a>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid footer-img" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid footer-shadow-1" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath2ImageVisible, footerImageWithBasePath2ImageRenderer, (
                <SmartImage src={footerImageWithBasePath2ImageSrc} alt={footerImageWithBasePath2ImageAlt} className="img-fluid footer-shadow-2" {...(footerImageWithBasePath2ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeEighteenFooterSectionGenerated;
